module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/chiba_funabashi_point2_3-d70fbcd9026bf6f3ae3f1e495f0168cb.jpg";